import { Component, OnDestroy, OnInit } from '@angular/core';
import {
    AlertService,
    AuthenticationService,
    button,
    BUTTONS,
    ChassisFormHandler,
    FormFactory,
    LoaderService,
    MultiTenantService,
    PluginDataInterface,
    ToolbarService,
    trans
} from '@kaiser-software/chassis-core';
import { CategoryModel } from '../../../models/category.model';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { CategoryService } from '../../../services/category.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { __ } from '@kaiser-software/chassis-localization';

@Component({
    selector: 'app-observation-categories-edit',
    templateUrl: 'edit.component.html',
    styleUrls: ['edit.component.scss']
})
export class CategoriesEditComponent implements OnInit, OnDestroy {

    public form: ChassisFormHandler;

    public model: CategoryModel;

    protected singular = 'Category';

    protected plural = 'Categories';

    protected title = 'Edit category';

    protected routePrefix = 'observation-categories';

    protected pluginPrefix = 'eyewatch-observation-categories-edit';

    protected subject: ReplaySubject<CategoryModel> = new ReplaySubject();

    protected pluginData: PluginDataInterface;

    protected toolbar = {
        buttons: {
            delete: false,
        }
    };

    protected subscriptions = [];

    constructor(
        protected formFactory: FormFactory,
        protected categoryService: CategoryService,
        protected activatedRoute: ActivatedRoute,
        protected authService: AuthenticationService,
        protected multiTenantService: MultiTenantService,
        protected loaderService: LoaderService,
        protected toolbarService: ToolbarService,
        protected router: Router,
        protected alertService: AlertService,
    ) {
        this.model = this.categoryService.make();
    }

    public ngOnInit(): void {
        this.activatedRoute.params.subscribe((params: Params) => {

            const subscription = this.multiTenantService.getScope()
                .subscribe((scope) => {
                    console.log('subscribe scope', scope);

                    this.categoryService.oneWith(params['category'], ['category']).subscribe((category: CategoryModel) => {
                        this.model.fill(category.plain());
                        this.subject.next(this.model);
                    });
                });


            this.subscriptions.push(subscription);
        });

        this.setupPlugins();

        this.createForm();
    }

    public ngAfterViewInit(): void {
        this.addDeleteButton();
    }

    protected addDeleteButton(): void {
        const loader = this.loaderService.create();

        this.toolbarService.add(
            button(BUTTONS.DELETE, {
                callback: () => {
                    loader.start();

                    const alert = this.alertService.open({
                        message: __('Are you sure?'),
                    });

                    alert.closed(() => {
                        this.model.delete()
                            .subscribe(() => {
                                loader.stop();

                                this.router.navigate(['/', 'observation_categories']);
                            });
                    });

                    alert.dismissed(() => {
                        loader.stop();
                    });
                },
                loader: () => {
                    return loader.isLoading();
                }
            })
        );
    }

    protected fields(): any {
        return {
            groups: [{
                id: 1,
                name: 'General',
                order: 1,
                sections: [{
                    id: 'section',
                    order: 1,
                    rows: [{
                        id: 'title',
                        order: -1,
                        elements: [{
                            id: 'title',
                            type: 'text',
                            name: 'title',
                            label: trans('Title'),
                            validation: {
                                required: true
                            },
                            attributes: {
                                placeholder: trans('Title'),
                                title: trans('Title')
                            }
                        }, {
                            id: 'code',
                            type: 'text',
                            name: 'code',
                            label: trans('Code'),
                            validation: {
                                required: true
                            },
                            attributes: {
                                placeholder: trans('Code'),
                                title: trans('Code')
                            }
                        }, {
                            id: 'description',
                            type: 'textarea',
                            name: 'description',
                            label: trans('Description'),
                            validation: {
                                required: true
                            },
                            attributes: {
                                placeholder: trans('Description'),
                                title: trans('Description')
                            }
                        }, {
                            id: 'category',
                            type: 'select-2',
                            name: 'category',
                            label: trans('Main category'),
                            config: {
                                url: this.categoryService.getEndpointUrl(),
                                useScope: false,
                                relation: true,
                                searchKeyColumn: 'id',
                                searchQueryColumn: 'title',
                                searchDisplayColumn: 'title',
                                params: {
                                    filter: 'id;code;title'
                                }
                            },
                            attributes: {
                                placeholder: trans('Main category'),
                                title: trans('Main category')
                            }
                        }],
                    }],
                }],
            }],
        };
    }

    public canSave() {
        return new Observable(observer => {
            this.authService
                .user()
                .subscribe(user => {
                    observer.next(
                        user.can('entities.observation_category.write')
                    );
                });
        });
    }

    protected createForm() {
        this.form = this.formFactory.create(
            this.fields(),
            this.model,
        );

        this.form.success((data) => {
            console.log(data);
        });
    }

    protected setupPlugins() {
        this.pluginData = {
            inputs: {
                form: this.form,
                model: this.subject,
            }
        };
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => {
            subscription.unsubscribe();
        });
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/observations/pages/categories/edit/edit.component.ts